<!-- Secondary navigation blocks component -->
<div role="list" class="jb-grid three-up">
  <jb-navigation-block
    *ngFor="let leg of navBlocks"
    role="listitem"
    type="secondary"
    class="mb2 mb4-ns"
    [target]="leg.link[0]?.newWindow"
    [href]="leg.link[0]?.href"
    [withTitlePadding]="false"
  >
    <ng-container JbTitle>
      <span>
        {{ leg.link[0]?.title }}
        <dot-link-icon
          [newWindow]="leg.link[0]?.newWindow === '_self' ? null : leg.link[0]?.newWindow"
        ></dot-link-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="leg.content" JbDescription>
      {{ leg.content }}
    </ng-container>
  </jb-navigation-block>
</div>
